import { Button, InformationCard } from '@yes.technology/react-toolkit'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18n-lite'
import HtmlEditor from './HtmlEditor/HtmlEditor'
import { ModalActions } from './HtmlEditorModal.styles'

type HtmlEditorModalProps = {
  isOpen: boolean
  title: string
  initialContent: string
  onClose: () => void
  onConfirm: (html: string) => void
}

const HtmlEditorModal = ({
  isOpen,
  title,
  initialContent,
  onClose,
  onConfirm
}: HtmlEditorModalProps) => {
  const { t } = useTranslation()
  const [draftContent, setDraftContent] = useState(initialContent)
  const didOpenRef = useRef(false)

  useEffect(() => {
    if (isOpen && !didOpenRef.current) {
      setDraftContent(initialContent)
      didOpenRef.current = true
    }

    if (!isOpen) {
      didOpenRef.current = false
    }
  }, [initialContent, isOpen])

  const handleConfirm = () => {
    onConfirm(draftContent)
    onClose()
  }

  return (
    <InformationCard
      isOpen={isOpen}
      title={title}
      close={onClose}
      style={{ width: '100%', maxWidth: 680 }}
    >
      <HtmlEditor content={draftContent} onChange={setDraftContent} />
      <ModalActions>
        <Button variant='secondary' type='button' onClick={onClose}>
          {t('data-tables.cancel')}
        </Button>
        <Button variant='primary' type='button' onClick={handleConfirm}>
          {t('data-tables.confirm')}
        </Button>
      </ModalActions>
    </InformationCard>
  )
}

export default HtmlEditorModal
